import { Pill } from "@/components/podkit/status/Pill";
import type { PlainWorkflowTrigger } from "@/queries/automation-queries";
import type { FC } from "react";
import type { PlainMessage } from "@bufbuild/protobuf";
import type {
    WorkflowTriggerContext_Projects,
    WorkflowTriggerContext_Repositories,
} from "gitpod-next-api/gitpod/v1/workflow_pb";
import { pluralize } from "@/utils/strings";

type WorkflowTriggerContextProps = {
    trigger: PlainWorkflowTrigger;
};

export const WorkflowTriggerContext: FC<WorkflowTriggerContextProps> = ({ trigger }) => {
    const contextCase = trigger.context?.context.case;

    if (!contextCase || !trigger.context) {
        return null;
    }

    switch (contextCase) {
        case "projects":
            return <ProjectsContext context={trigger.context.context.value} />;

        case "repositories":
            return <RepositoriesContext context={trigger.context.context.value} />;

        default:
            return null;
    }
};

type ProjectsContextProps = {
    context: PlainMessage<WorkflowTriggerContext_Projects>;
};

const ProjectsContext: FC<ProjectsContextProps> = ({ context }) => {
    const projectCount = context.projectIds.length;
    return (
        <Pill variant="info" size="sm" className="w-fit">
            {projectCount} {pluralize(projectCount, "project")}
        </Pill>
    );
};

type RepositoriesContextProps = {
    context: PlainMessage<WorkflowTriggerContext_Repositories>;
};

const RepositoriesContext: FC<RepositoriesContextProps> = ({ context }) => {
    if (context.repositorySelector?.case == "repositoryUrls") {
        const repoCount = context.repositorySelector.value.repoUrls.length;
        return (
            <Pill variant="info" size="sm" className="w-fit">
                {repoCount} {pluralize(repoCount, "repository", "repositories")}
            </Pill>
        );
    }

    if (context.repositorySelector?.case == "repoSelector") {
        const searchQuery = context.repositorySelector.value.repoSearchString;
        return (
            <Pill variant="info" size="sm" className="w-fit">
                {searchQuery}
            </Pill>
        );
    }

    return null;
};
